import { ReactNode } from 'react';
import { Trans } from 'react-i18next';

import useLeadChannelStore from '../../store/leadChannelStore/useLeadChannelStore';
import { DisclosureProps } from './types/DisclosureProps';

export const Disclosure = ({
  i18nKey,
  privacyLinkTestId,
  termsLinkTestId,
}: DisclosureProps): ReactNode => {
  const {
    computed: {
      disclosureBrand,
      phoneNumberWithCountryCode,
      privacyPolicyURL,
      termsOfUseURL,
    },
  } = useLeadChannelStore();

  return (
    <Trans
      components={{
        phone: <a href={`tel:${phoneNumberWithCountryCode}`} />,
        privacy: (
          <a
            data-testid={privacyLinkTestId}
            href={privacyPolicyURL}
            rel="noreferrer"
            target="_blank"
          />
        ),
        terms: (
          <a
            data-testid={termsLinkTestId}
            href={termsOfUseURL}
            rel="noreferrer"
            target="_blank"
          />
        ),
      }}
      i18nKey={i18nKey}
      values={{
        brand: disclosureBrand,
        phoneNumber: phoneNumberWithCountryCode,
      }}
    />
  );
};
